import SiteFooter from './SiteFooter';

export default SiteFooter;
